import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import '@/icons' // icon
import '@/permission' // permission control
import mixin from '@/mixin'
import bug from '@/bug'
import global from '@/global' // global config
import 'lib-flexible'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import track from './track'
// import VConsole from 'vconsole'
import tooltip from './tooltip'
// new VConsole()

Vue.use(VXETable)

// 二维码生成
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

// set ElementUI lang to EN
Vue.use(ElementUI, { locale, size: 'mini' })

Vue.config.productionTip = false

Vue.prototype.$global = global

Vue.mixin(mixin)

bug.vueError()

Vue.directive('track', track)
Vue.directive('tooltip', tooltip)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
